/**
 * Ryan O'Dowd
 * 2023-05-02
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
    },
    verseHeading: {
      alignSelf: 'flex-start', // necessary to keep the text from filling all available width
      color: colors.white,
      paddingBottom: globalScale * 8,
      fontSize: globalScale * 18,
      fontFamily: fonts.secondaryBold,
    },
    verseWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 6,
      paddingTop: 0,
      borderLeftWidth: 4,
      borderRightWidth: 4,
      borderLeftColor: 'transparent',
      borderRightColor: 'transparent',
    },
    verseText: {
      display: 'flex',
      flexShrink: 1,
    },
    allBadgesWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    verseWrapperNoFormatting: {
      paddingBottom: 8,
    },
    selectedVerseWrapper: {
      borderLeftColor: colors.qqq,
    },
    selectedVerseNumber: {
      color: colors.qqq,
      fontFamily: fonts.primaryBold,
    },
    selectedVerseText: {
      textDecorationLine: 'underline', // @TODO: on android, this is underlining newline characters as well
      color: colors.qqq,
    },
    verseNumber: {
      position: 'absolute',
      top: -2,
      left: 2,
      fontSize: globalScale * 12,
      color: colors.lightGray,
    },
    typedVerse: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      // @TODO: flexDirection: 'row',
      // @TODO: flexWrap: 'wrap',
      fontSize: globalScale * 16, // @TODO: toggleable
      color: colors.white,
      opacity: 1,
    },
    openVerseWrapper: {
      borderLeftColor: colors.alert, // @TODO: don't love the alert color...but need a good way to indicate which verses are open and which are waiting
    },
    completedVerseWrapper: {
      borderRightColor: colors.accent,
    },
    completedVerseText: {
      color: colors.accent,
    },
    inProgressVerseWrapper: {
      borderRightColor: colors.complete,
    },
    inProgressVerseText: {
      color: colors.complete, // @TODO: this needs to be updated in light mode
    },
    unstartedVerseWrapper: {
      borderRightColor: colors.lightGray, // @TODO: prettier color
    },
    unstartedVerseText: {
    },
    footnoteIndicatorWrapper: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      flexShrink: 1,
    },
    footnoteIndicator: { // @TODO: combine with verse number styles
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      position: 'relative',
      top: -4, // @TODO: shouldn't be affected by $globalScale
      color: colors.accent, // @TODO: update
      fontSize: globalScale * 12,
    },
    skeletonWrapper: {
      paddingHorizontal: 16,
    },
    skeletonHeading: {
      height: 24,
      marginBottom: 12,
      width: '60%',
    },
    skeletonFirstLine: {
      width: '95%',
      alignSelf: 'flex-end',
    },
    skeletonLastLine: {
      width: '75%',
      marginBottom: 12,
    },

    // @MARK: numbers only styles
    numsOnlyVerseNumber: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 36,
      height: 36,
      backgroundColor: colors.primaryDark,
      borderWidth: 4,
      borderColor: colors.primaryLight,
      borderRadius: 8,
      margin: 4,
      padding: 0,
    },
    verseNumberText: {
      color: colors.white,
      fontSize: 14,
      fontFamily: fonts.primaryBold,
    },
    highlightedVerse: {
      borderLeftWidth: 4,
      borderLeftColor: colors.inContextHightlight,
    },
    highlightedText: {
      color: colors.inContextHightlight,
    },
    numsOnlySelectedVerse: {
      borderColor: colors.qqq,
    },
    numsOnlyCompletedVerse: {
      borderColor: colors.accent,
    },
    numsOnlyCompletedVerseText: {
      color: colors.accent,
    },
    numsOnlyInProgressVerse: {
      borderColor: colors.complete,
    },
    numsOnlyInProgressVerseText: {
      color: colors.complete,
    },
    numsOnlyUnstartedVerse: {
      borderColor: colors.lightGray,
    },
    numsOnlyUnstartedVerseText: {
      color: colors.lightGray,
    },
  };
};

export default getStyles;
